(function () {
	'use strict';
	angular
		.module('jcsfApp')
		.controller('nonpublicprojectController', nonpublicprojectController);
	nonpublicprojectController.$inject = [
		'$controller',
		'$rootScope',
		'$scope',
		'events',
		'authService',
		'dataService',
	]; //
	function nonpublicprojectController(
		$controller,
		$rootScope,
		$scope,
		events,
		authService,
		dataService
	) {
		//
		$controller('baseController', { $scope: $scope });
		var vm = this;
		authService.fillAuthData();
		var authentication = authService.authentication;
		vm.orderBy =
			sessionStorage.getItem('nonPublicProjectOrderBy') || 'LastName';
		vm.orderByReverse = false;
		vm.setOrderBy = setOrderBy;
		vm.baseUrl = '/api/NonPublicProject/';
		vm.project = {};
		vm.students = [];
		vm.centers = [];
		vm.userJCCCC = authService.authentication.userInfo.JCCCC;
		vm.centerId = authService.authentication.userInfo.JCCCC;
		vm.centerName = '';
		vm.centerStudents = [];
		vm.forests = [];
		vm.projectDocuments = [];
		vm.CalcFiscalYear = function () {
			var dToday = new Date();
			if (dToday.getMonth() > 5) return dToday.getFullYear() + 1;
			else return dToday.getFullYear();
		};
		vm.cancel = function () {
			$scope.publish(events.message._GET_NON_PUBLIC_PROJECT_, [
				vm.project.ProjectId,
			]);
		};

		vm.handleCommPVChange = function (e) {
			vm.project.ProjectVerified = false;
		};

		vm.save = function () {
			vm.project.Active = 1;
			if (vm.project.ProjectId > 0) {
				vm.project.LastModifiedBy = authentication.userName;
			} else {
				vm.project.Creator = authentication.userName;
			}

			$scope.publish(events.message._SAVE_NON_PUBLIC_PROJECT_, [vm.project]);
		};
		vm.selectedStudentHour = { CalendarYear: vm.CalcFiscalYear() };
		vm.saveNPHours = function (np) {
			console.log("SaveNPHours with variable: ", np);
			if (np.NPHoursId > 0) {
				np.LastModifiedBy = authentication.userName;
			} else {
				np.Creator = authentication.userName;
			}
			vm.save();
			for (const student of vm.selectedStudents) {
				const sf = structuredClone(np);
				sf.StudentId = student.StudentId;
				$scope.publish(events.message._SAVE_NON_PUBLIC_HOUR_, [sf]);
			}
			vm.selectedStudentHour = createNPHourModel();
			vm.selectedStudents = [];
		};
		vm.deleteNPHour = function (np) {
			var confirmed = window.confirm(
				'Are you sure you want to delete ' +
					np.FirstName +
					' ' +
					np.LastName +
					' Hours (' +
					np.Hours +
					') ?'
			);
			if (confirmed) {
				$scope.publish(events.message._DELETE_NON_PUBLIC_HOUR_, [np.NPHoursId]);
			}
		};

		vm.isStudentActive = function isStudentActive(fh) {
			return vm.students.some(function (st) {
				return st.StudentId === fh.StudentId;
			});
		};

		vm.editStudentHour = function editStudentHour(np) {
			const student = vm.students.find(function (st) {
				return st.StudentId === np.StudentId;
			});

			if (student) {
				vm.selectedStudents = [student];
			} else {
				alert('Student not found in active records. Aborting edit attempt.');
				return;
			}
			vm.selectedStudentHour = createNPHourModel(np);
			vm.selectedStudentHour.Hours = parseFloat(
				Math.round(vm.selectedStudentHour.Hours * 100) / 100
			);
			vm.selectedStudentHour.EstimatedHours = parseFloat(
				Math.round(vm.selectedStudentHour.EstimatedHours * 100) / 100
			);
		};

		vm.totalHours = function (fh) {
			var totalHours = 0;
			try {
				vm.project.ProjectHours.forEach(function (item) {
					totalHours = totalHours + Number(item.Hours);
				});
			} catch (e) {
				totalHours = 0;
			}
			return totalHours;
		};
		vm.changeCenter = centerChanged;
		vm.selectedStudents = [];
		activate();
		$scope.subscribe(
			events.message._GET_NON_PUBLIC_PROJECT_COMPLETE_,
			onGetProjectComplete
		);
		$scope.subscribe(
			events.message._SAVE_NON_PUBLIC_PROJECT_COMPLETE_,
			onSaveProjectComplete
		);
		$scope.subscribe(
			events.message._GET_JCCENTER_LIST_COMPLETE_,
			onGetJcCentersComplete
		);
		$scope.subscribe(
			events.message._GET_STUDENT_LIST_COMPLETE_,
			onGetStudentsComplete
		);
		$scope.subscribe(
			events.message._SAVE_NON_PUBLIC_HOUR_COMPLETE_,
			onSaveNPHourComplete
		);
		$scope.subscribe(
			events.message._DELETE_NON_PUBLIC_HOUR_COMPLETE_,
			onSaveNPHourComplete
		);
		$scope.subscribe(
			events.message._GET_FOREST_LIST_COMPLETE_,
			onGetForestsComplete
		);
		function activate() {
			if (
				authentication.userName === null ||
				authentication.userName === undefined ||
				!authentication.isAuth
			) {
				$scope.$state.go('login');
			}
			if (
				$rootScope.$stateParams.id === null ||
				$rootScope.$stateParams.id === undefined
			) {
				$scope.$state.go('home');
			}
			$scope.publish(events.message._GET_JCCENTER_LIST_, []);
			$scope.publish(events.message._GET_NON_PUBLIC_PROJECT_, [
				$rootScope.$stateParams.id,
			]);
			$scope.publish(events.message._GET_FOREST_LIST_, []);
		}
		function centerChanged(id) {
			vm.centerStudents = [];
			vm.selectedStudents = [];

			$scope.publish(events.message._GET_STUDENT_LIST_, [true, id]);
			vm.centerStudents = vm.students.filter(function (st) {
				return st.JCCCC === Number(id);
			});
			vm.handleCommPVChange();
		}
		function onGetProjectComplete(results) {
			vm.project = results;

			vm.selectedStudentHour = createNPHourModel();
			if (vm.project.ProjectId < 1 && vm.userJCCCC != 29) {
				vm.project.PartnerOrganizationId = vm.userJCCCC;
			}
			$scope.publish(events.message._GET_STUDENT_LIST_, [
				true,
				vm.project.PartnerOrganizationId,
			]);

			getProjectDocuments(vm.project.ProjectId);
			if (vm.students.length)
				vm.centerStudents = vm.students.filter(function (st) {
					return st.JCCCC === Number(vm.project.PartnerOrganizationId);
				});
		}
		function onGetForestsComplete(results) {
			vm.forests = results;
		}
		function onSaveProjectComplete(results) {
			onGetProjectComplete(results);
		}
		function onGetJcCentersComplete(results) {
			vm.centers = results;
			if (vm.userJCCCC !== 29) {
				vm.centerId = vm.userJCCCC;
			} else if (
				$rootScope.$stateParams.id !== null &&
				$rootScope.$stateParams.id !== undefined
			) {
				if (vm.userJCCCC !== 29) {
					vm.centerId = vm.userJCCCC;
				} else {
					vm.centerId = $rootScope.$stateParams.id;
				}
			}
		}
		function onGetStudentsComplete(results) {
			vm.students = results;
			if (vm.project)
				vm.centerStudents = vm.students.filter(function (st) {
					return st.JCCCC === Number(vm.project.PartnerOrganizationId);
				});
		}

		function createNPHourModel(src) {
			var self = {};
			src = src || {};
			self.NPHoursId = src.NPHoursId || 0;
			self.StudentId = src.StudentId || 0;
			self.ProjectId = vm.project.ProjectId || 0;
			self.CalendarYear = src.CalendarYear || vm.CalcFiscalYear();
			self.FirstName = src.FirstName || '';
			self.MiddleInitial = src.MiddleInitial || '';
			self.LastName = src.LastName || '';
			self.IsPLC = src.IsPLC || false;
			self.DispatchDate = new Date(src.DispatchDate);
			self.ReturnedDate = new Date(src.ReturnedDate);
			self.EstimatedHours = src.EstimatedHours || 0;
			self.Hours = src.Hours || 0;
			self.Active = src.Active || 1;
			self.Deleted = src.Deleted || 0;
			self.Creator = src.Creator || '';
			self.LastModifiedBy = src.LastModifiedBy || '';
			self.CreatedDate = new Date(src.CreatedDate);
			self.CreatedDateString = src.CreatedDateString || '';
			self.CreatedBy = src.CreatedBy || '';
			self.LastUpdated = new Date(src.LastUpdated);
			self.LastUpdatedString = src.LastUpdatedString || '';
			self.LastUpdatedBy = src.LastUpdatedBy || '';
			self.UpdatingApp = src.UpdatingApp || '';
			self.ProjectHours = src.ProjectHours || [];
			self.fullName = ((src.LastName || '') + ', ' + src.FirstName + ', ' + (src.MiddleInitial || '')) || '';
			return self;
		}

		function onSaveNPHourComplete() {
			$scope.publish(events.message._GET_NON_PUBLIC_PROJECT_, [
				vm.project.ProjectId,
			]);
		}

		function getProjectDocuments(projectId) {
			dataService
				.get(vm.baseUrl + 'getProjectFiles/' + projectId)
				.then(function (result) {
					vm.projectDocuments = result;
				});
		}

		function deleteDocumentFromServer(fileID, fileName) {
			dataService
				.get(vm.baseUrl + 'DeleteProjectFileV2/' + fileID)
				.then(function (result) {
					getProjectDocuments(vm.project.ProjectId);
				});
		}

		vm.viewFile = function (fileName) {
			window.open('Uploads/' + fileName);
		};

		vm.deleteFile = function (fileID, fileName) {
			if (confirm('Are you sure you want to delete this document') == true) {
				deleteDocumentFromServer(fileID, fileName);
			}
		};

		vm.doSaveFile = function () {
			doFileUploads(vm);
		};

		function doFileUploads(objProject) {
			let ProjectId = objProject.project.ProjectId;
			let LastUpdatedBy = objProject.project.LastUpdatedBy;

			if (document.getElementById('fileUploadDocs').value != '') {
				var file = document.getElementById('fileUploadDocs').files[0];
				var fileName = document.getElementById('fileUploadDocs').files[0].name;
				if (window.FormData !== undefined) {
					var data = new FormData();
					data.append('file', file);
					$.ajax({
						type: 'POST',
						url:
							'/api/NonPublicProject/UploadFile/' +
							ProjectId +
							'/' +
							LastUpdatedBy +
							'/' +
							'abc',
						contentType: false,
						processData: false,
						data: data,
						success: function (result) {
							getProjectDocuments(objProject.project.ProjectId);
						},
						error: function (xhr, status, p3, p4) {
							var err = 'Error ' + ' ' + status + ' ' + p3 + ' ' + p4;
							if (xhr.responseText && xhr.responseText[0] == '{')
								err = JSON.parse(xhr.responseText).Message;
							console.error(err);
							getProjectDocuments(objProject.project.ProjectId);
						},
					});
				}
				document.getElementById('fileUploadDocs').value = '';
				document.getElementById('btnSaveDoc').disabled = true;
			}
		}
	}

	/**
	 *
	 * @param {string} column
	 */
	function setOrderBy(column) {
		vm.orderByReverse = vm.orderBy === column ? !vm.orderByReverse : false;
		vm.orderBy = column;
		sessionStorage.setItem('nonPublicProjectOrderBy', column);
	}
})();
